module.exports = __webpack_public_path__ + "img/yt.ca077cbe.png";